import Phase from '../phase-core/Phase';

export default class Show extends Phase.Config {

	constructor(name, offset = 0) {
		super();
		this.name = name;
		this.offset = offset;
	}

	getPreludeLength() {
		return this.offset;
	}

	run({ layers }) {
		layers[this.name] = true;
	}

}
